// Generated by BUCKLESCRIPT VERSION 4.0.14, PLEASE EDIT WITH CARE
'use strict';

var Curry = require("bs-platform/lib/js/curry.js");

var Caml_obj = require("bs-platform/lib/js/caml_obj.js");

var eq = Caml_obj.caml_equal;

function eqBy(f, a, b) {
  return Caml_obj.caml_equal(Curry._1(f, a), Curry._1(f, b));
}

function identical(a, b) {
  return a === b;
}

exports.eq = eq;
exports.eqBy = eqBy;
exports.identical = identical;
/* No side effect */